import { IParameterPDTO } from "../models/dtos/parameterPDTO";
import { IFilter } from "../models/filters/filter";
import { IParameterFilter } from "../models/filters/parameterFilter";
import { IParameterForm } from "../models/forms/parameterForm";
import _o2sService from "./_o2sServices";
import { API_CENTRE } from "./config";


export default class ParameterServices extends _o2sService
{
    protected static override mainUrl:string = API_CENTRE + "/api/v1/parameters";

    public static switchAPI(api: string) {
        this.mainUrl = api + "/api/v1/parameters";
    }

    protected static override getUrlFilter<F extends IParameterFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null) 
        {
            if ( filter.code1 != null)
                url += `&Code1=${filter.code1}`;
            if ( filter.code2 != null)
                url += `&Code2=${filter.code2}`;
        }
        return url;
    }
    
    protected static override toDTO(obj:IParameterForm):IParameterPDTO {
        const dto = super.toDTO(obj) as IParameterPDTO;
        
        return dto;
    }
}